import { InfoButton, InfoButtonTrigger } from '@optools/components/info-button';
import { SheetDescription, SheetHeader, SheetTitle } from '@optools/components/ui/sheet';
import { MediaPolicy } from '@optools/services/operator-gateway/types/generated/graphql';
import { Link } from '@tanstack/react-router';
import { ReactNode } from 'react';

import { EsniTeamSpot } from './esni-team-spot';
import { PoliciesTable } from './policies-table';

const Section = ({ children, id, title }: { children: ReactNode; id: string; title: string }) => (
  <div className="flex h-full flex-col gap-1 whitespace-nowrap">
    <dt className="text-xs" id={id}>
      {title}
    </dt>
    <dd aria-labelledby={id} className="flex flex-1 items-center text-sm capitalize">
      {children}
    </dd>
  </div>
);

export interface MediaDetailProps {
  mediaPolicy: MediaPolicy;
}

export function MediaDetail({ mediaPolicy }: MediaDetailProps) {
  const { feedSubType, feedType, id: mediaId = '', mediaType } = mediaPolicy;

  return (
    <div className="flex h-full flex-col">
      <SheetHeader>
        <SheetTitle className="mb-6">Media</SheetTitle>
        <SheetDescription className="sr-only">
          View and Edit Media Feed Policy Details
        </SheetDescription>
      </SheetHeader>
      <div className="mb-12 flex flex-wrap justify-between">
        <div className="flex flex-wrap items-start gap-8">
          <Section id="media-id" title="Media ID">
            {mediaId}
          </Section>
          <Section id="feed-type" title="Feed Type">
            {feedType}
          </Section>

          <Section id="media-type" title="Media Type">
            {mediaType}
          </Section>

          <Section id="sub-type" title="Team">
            <EsniTeamSpot feedSubType={feedSubType ?? ''} />
          </Section>
        </div>
        <InfoButton
          className="self-center"
          description="Validate and Process Media through ESNI Rules matcher to attach viewing policies."
          size="sm">
          <InfoButtonTrigger asChild>
            <Link from="/" search={{ mediaId }} to="/esni/rules/process">
              Process Rules
            </Link>
          </InfoButtonTrigger>
        </InfoButton>
      </div>

      <PoliciesTable mediaPolicy={mediaPolicy} />
    </div>
  );
}
